import {makeAutoObservable} from "mobx";
import {getStore, useStore} from "./index";
import MainFolderTrashModal from "../../components/modal/MainFolderTrashModal";
import ProductConnectModal from "../../components/modal/ProductConnectModal";
import EditorFolderModal from "../../components/modal/EditorFolderModal";
import SaveItemModal from "../../components/modal/SaveItemModal";
import PreviewModal from "../../components/modal/PreviewModal";
import CommentWriteModal from "../../components/modal/CommentWriteModal";
import CommonBoardPreviewModal from "../../components/modal/CommonBoardPreviewModal";
import CommonConnectedPrdModal from "../../components/modal/CommonConnectedPrdModal";
import CommonBoardEditorModal from "../../components/modal/CommonBoardEditorModal";
import MoveItemModal from "../../components/modal/MoveItemModal";
import AccountModal from "../../components/modal/AccountModal";
import ChangePassword from "../../routes/ChangePassword";
import ProductLiveSetTimeModal from "../../components/modal/ProductLiveSetTimeModal";
import FitGuidePreviewModal from "../../components/modal/FitGuidePreviewModal";


const entryTypeLocaleMap = {
    TEMPLATE: '템플릿보드', CLIP: '클립보드', COMMON: '공통보드', PAGE: '페이지', CLIP_SET: '클립보드 세트'
}

export class ModalStore {
    store;
    /**
     * @typedef {object} ModalInfo
     * @property {object} modalProps
     * @property {boolean} isOpen
     * @property {string} title
     * @property {function?} modalMutate
     * @property {React.FunctionComponent} component
     */
    /**
     * @typedef {object} ModalConfig
     * @property {object} modalProps
     * @property {React.FunctionComponent} component
     * @property {boolean} isOpen
     * @property {string} title
     * @property {function} modalMutate
     * @property {function?} closeFunc
     * @property {boolean} isFirst
     */
    /**
     * @typedef {object} ModalProps
     * @property {number?} width
     * @property {number?} height
     * @property {string} modalTitle
     * @property {string?} entryType
     * @property {Folder[]|File[]|undefined} saveItems
     * @property {string?} content
     */

    /** @type {Record<string,ModalConfig|function>} */
    MODAL_PAYLOAD = {
        ACCOUNT_SETTING: (type) => {
            return {
                modalProps: {
                    width: 400,
                    height: 570,
                    modalTitle: `${type === 'UPDATE' ? '계정 설정' : '신규 계정 추가'}`,
                    entryType: type,
                    type: "ACCOUNT_SETTING",
                },
                component: AccountModal
            }
        },
        TRASH_FOLDER: (entryType) => {
            return { // 휴지통
                modalProps: {
                    width: 820,
                    height: 720,
                    modalTitle: `${entryTypeLocaleMap[entryType]} 휴지통`,
                    entryType: entryType,
                    type: "TRASH_FOLDER",
                },
                component: MainFolderTrashModal
            }
        },
        PRODUCT_CONNECT: { // 연결 상품
            modalProps: {
                width: 1000,
                modalTitle: '상품 연결',
                type: "PRODUCT_CONNECT",
            },
            component: ProductConnectModal
        },
        EDITOR_FOLDER: (entryType) => {
            return { // 현재 폴더
                modalProps: {
                    width: 840,
                    height: 720,
                    modalTitle: `${entryTypeLocaleMap[entryType]} 관리`,
                    type: "EDITOR_FOLDER",
                },
                component: EditorFolderModal
            }
        },
        SAVE_ITEM: (entryType, saveItem) => {
            return { // 폴더 저장 모달
                modalProps: {
                    width: 440,
                    modalTitle: `${entryTypeLocaleMap[entryType]} 저장`,
                    entryType: entryTypeLocaleMap[entryType] === '클립보드 세트' ? 'CLIP' : entryType,
                    saveItem: saveItem,
                    type: "SAVE_ITEM",
                },
                component: SaveItemModal
            }
        },
        MOVE_ITEM: (entryType) => {
            return {
                modalProps: {
                    width: 440,
                    height: 600,
                    modalTitle: '이동',
                    entryType: entryType,
                    type: "MOVE_ITEM",
                },
                component: MoveItemModal
            }
        },
        EDITOR_CURRENT_PREVIEW: (content, subContent, captureContent) => {
            return { // 현재 에디터 미리보기
                modalProps: {
                    width: 900,
                    height: 790,
                    modalTitle: '상품 상세 설명 미리보기',
                    content: content,
                    subContent: subContent,
                    captureContent: captureContent,
                    type: "EDITOR_CURRENT_PREVIEW",
                },
                component: PreviewModal
            }
        },


        FIT_GUIDE_PREIVEW: (content, selectedDevice) => {
            return { // 현재 에디터 미리보기
                modalProps: {
                    width: `${selectedDevice === "pc" ? 774 : 480}`,
                    height: 800,
                    modalTitle: '기장 가이드 미리보기',
                    content: content,
                    device: selectedDevice,
                    type: "FIT_GUIDE_PREIVEW",
                },
                component: FitGuidePreviewModal
            }
        },


        COMMENT_WRITE: { // 코멘트 작성
            modalProps: {
                width: 360,
                height: 335,
                modalTitle: '코멘트 작성',
                type: "COMMENT_WRITE",
            },
            component: CommentWriteModal
        },


        COMMON_BOARD_PREVIEW: (id) => {
            return {
                modalProps: {
                    width: 900,
                    id: id,
                    modalTitle: '공통보드 미리보기',
                    type: "COMMON_BOARD_PREVIEW",
                },
                component: CommonBoardPreviewModal
            }
        },


        PRODUCT_CONNECT_BOARD: { // 공통 보드 엮인 상품
            modalProps: {
                width: 560,
                height: 670,
                modalTitle: '엮인 상품',
                type: "PRODUCT_CONNECT_BOARD",
            },
            component: CommonConnectedPrdModal
        },

        COMMON_BOARD_EDITOR: (boardData) => {
            return { // 공통 보드 에디터
                modalProps: {
                    width: 1120,
                    modalTitle: '공통보드 수정하기',
                    boardData: boardData,
                    type: "COMMON_BOARD_EDITOR",
                },
                component: CommonBoardEditorModal
            }
        },


        CHANGE_PASSWORD: { // 비밀 번호 변경
            modalProps: {
                width: 700,
                height: 600,
                modalTitle: '비밀번호 변경',
                type: "CHANGE_PASSWORD",
            },
            component: ChangePassword
        },

        PRODUCT_LIVE_SET_TIME: { // 라이브 시간 세팅
            modalProps: {
                width: 575,
                height: 240,
                modalTitle: '라이브 시간 세팅',
                type: "PRODUCT_LIVE_SET_TIME",
            },
            component: ProductLiveSetTimeModal
        },
    }
    /** @type {ModalInfo[]} */
    MODAL_INIT_OPENED = [];
    isOpenChangeName = false;

    constructor(store) {
        this.store = store;
        makeAutoObservable(this, {}, {autoBind: true});
    }


    /**
     * 모달을 오픈하면서 모달 스택에 열린 모달을 추가해주는 함수
     * @param {*&{isFirst: boolean}} config 모달의 설정
     * @param {function?} mutate 새로고침이 필요한 화면의 경우 새로고침 함수를 입력받는다
     */
    openModal(config, mutate) {
        this.MODAL_INIT_OPENED.push(
            {
                modalProps: config.modalProps,
                isOpen: true,
                title: config.modalProps.modalTitle,
                modalMutate: mutate,
                component: config.component,
                closeFunc: config.closeFunc || null,
                isFirst: config.isFirst
            }
        );
    }

    /**
     * 전체 모달창을 한번에 초기화하는 함수
     */
    clear() {
        this.MODAL_INIT_OPENED = [];
    }

    /**
     * 모달창을 한개씩 제거할 때 사용되는 함수
     * @return {ModalInfo}
     */
    pop() {
        return this.MODAL_INIT_OPENED.pop();
    }

    setIsOpenChangeName(config) {
        this.isOpenChangeName = config;
    }
}

export const useModalStore = () => {
    return useStore().modalStore;
}

export const getModalStore = () => {
    return getStore().modalStore;
}